/**
 * Created by Administrator on 2017-11-9.
 */
export const ERR_OK = 'SUCCESS'

export const ERR_ERR = 'F001'

export const ERR_ERR_NORIGHT = 'F010'//没权限

export const ERR_TIMEOUT = '9000000'

export const ERR_FAILSHOW = '9000001'

export const ERR_FAILTIP = '9000002'

export const ERR_FAILBACKSTAGE = 'system'

export const SEXOBJ = {
    '0': '女',
    '1': '男'
}
export const privateType = {
    '0': '公共',
    '1': '私人',
    '2': '部门',
    '3': '医院'
}

export const MESSAGE_DURATION = 2000
// 手机号正则
export const phoneReg = (/^[0-9]{11}$/)
// 密码正则
export const pwdReg = (/^(?![A-Z]+$)(?![a-z]+$)(?!\d+$)(?![\W_]+$)\S{6,20}$/)
// 身份证正则
export const idReg = (/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/)
// 医院编码正则
export const hosIdReg = (/^\d{8}$/)
// 机构代码正则
export const hosCodeReg = (/^[a-zA-Z\d]{22}$/)
// 账户名正则
export const accountReg = (/^[a-zA-Z\d]{40}$/)
// 医联体正则
export const mcReg = (/^[a-zA-Z\d]{10}$/)
// 名称正则匹配中英文和下划线
export const nameReg = (/^[a-zA-Z\u4e00-\u9fa5]+$/)
// 分类编码正则(限制数字10位数)
export const codeReg = (/^[\d]{0,10}$/)
// 邮箱正则
export const mailReg = (/^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/)
// url正则
export const urlReg = /^(https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]$/
// 只能输入数字
export const numReg = (/^[0-9]*$/)
// 科室编码正则
export const deptReg = (/^\w{1,12}$/)



// WEBPACK FOOTER //
// ./src/common/js/config.js